// Updated by Elevate: 2026-01-02T23:25:06.198Z
// Lazy load Google Fonts for better performance
(function() {
  'use strict';

  // Check if fonts are already loaded
  function isFontLoaded(href) {
    const links = document.querySelectorAll('link[rel="stylesheet"]');
    for (let link of links) {
      if (link.href && link.href.includes(href)) {
        return true;
      }
    }
    return false;
  }

  function hasIconClass(selector) {
    return Boolean(document.querySelector(selector));
  }

  // Load only icon font families used by the rendered page.
  function loadFonts() {
    const fontCandidates = [
      {
        selector: '.material-icons',
        url: 'https://fonts.googleapis.com/icon?family=Material+Icons'
      },
      {
        selector: '.material-icons-outlined',
        url: 'https://fonts.googleapis.com/icon?family=Material+Icons+Outlined'
      },
      {
        selector: '.material-icons-round',
        url: 'https://fonts.googleapis.com/icon?family=Material+Icons+Round'
      },
      {
        selector: '.material-icons-sharp',
        url: 'https://fonts.googleapis.com/icon?family=Material+Icons+Sharp'
      },
      {
        selector: '.material-icons-two-tone',
        url: 'https://fonts.googleapis.com/icon?family=Material+Icons+Two+Tone'
      },
      {
        selector: '.material-symbols-rounded',
        url: 'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@24,400,0,0'
      },
      {
        selector: '.material-symbols-sharp',
        url: 'https://fonts.googleapis.com/css2?family=Material+Symbols+Sharp:opsz,wght,FILL,GRAD@24,400,0,0'
      }
    ];

    const fontsToLoad = fontCandidates
      .filter(function(font) {
        return hasIconClass(font.selector);
      })
      .map(function(font) {
        return font.url;
      });

    fontsToLoad.forEach(function(fontUrl) {
      // Skip if already loaded
      if (isFontLoaded(fontUrl)) return;

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = fontUrl + '&display=swap'; // Add font-display: swap
      link.media = 'print'; // Load as print first
      link.onload = function() {
        this.media = 'all'; // Switch to all media when loaded
        this.onload = null; // Prevent multiple calls
      };

      // Add crossorigin for Google Fonts
      if (fontUrl.includes('fonts.googleapis.com')) {
        link.crossOrigin = 'anonymous';
      }

      document.head.appendChild(link);
    });
  }

  // Use requestIdleCallback if available, otherwise use setTimeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadFonts, { timeout: 3000 });
  } else {
    setTimeout(loadFonts, 100);
  }
})();
